/* eslint-disable react/prop-types */
import React  from "react";
import { Button, Typography, Box } from "@mui/material";
import { formatToNDecimalPlaces } from "../../../../_utils/formatToNDecimalPlaces";
const CourseCardFooter = ({ price,customfontsize }) => {

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap-reverse",
        mt: 2,
        width: "100%",
      }}
    >
      <Button
        variant="contained"
        href="/course-details"
        sx={{
          boxShadow: "4px 4px 10px rgba(97, 97, 97, 0.8)",
          transition: "box-shadow 0.3s ease-in-out",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: `${.8*customfontsize}px`,
          "&:hover": {
            boxShadow: "0px 0px 0px rgba(0, 0, 0, 0)",
          },
        }}
      >
        Enroll Now
      </Button>
      <Typography
        color="error"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          fontSize: `${customfontsize}px`,
          ml: "auto",
        }}
      >
        ${formatToNDecimalPlaces(price)}
      </Typography>
    </Box>
  );
};

export default CourseCardFooter;
